<template>
    <div class="fordable">
        <div class="common_table custom_scroll">
            <table>
                <colgroup>
                    <col style="width: 60px" />
                    <col style="width: 70px" />
                    <col style="width: 210px" />
                    <col />
                    <col style="width: 120px" />
                    <col style="width: 80px" />
                    <col style="width: 80px" />
                    <col style="width: 80px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>순서</th>
                        <th>번호</th>
                        <th>게시판 이름</th>
                        <th>제목</th>
                        <th>조회수</th>
                        <th>이미지</th>
                        <th>메인노출</th>
                        <th>삭제</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="listState.list && listState.list.length > 0">
                        <tr v-for="(item, idx) in listState.list" :key="idx">
                            <td class="cnt">
                                <template v-if="item.isMain === 1">
                                    <button type="button" class="move_up _sub" @click="changeOrder(item, 0)">
                                        <img src="img/up_icon.png" alt="" />
                                    </button>
                                    <button type="button" class="move_down _sub" @click="changeOrder(item, 1)">
                                        <img src="img/down_icon.png" alt="" />
                                    </button>
                                </template>
                            </td>
                            <td class="list_num">{{ (listState.page - 1) * listState.size + idx + 1 }}</td>
                            <td>{{ item.type === 1 ? "반성매매 시민활동" : "캠페인·이벤트" }}</td>
                            <td>{{ item.title }}</td>
                            <td>{{ CommonUtils.numberFormat(item.viewCnt) }}</td>
                            <td class="cnt">
                                <button type="button" class="tb_img img_wrap" @click="viewImage(item.thumbnail)" v-if="item.thumbnail">
                                    <img :src="item.thumbnail" alt="" />
                                </button>
                            </td>
                            <td class="cnt checkbox_wrap _plus">
                                <label :for="'chk_1_entire' + item.idx">
                                    <input
                                        :id="'chk_1_entire' + item.idx"
                                        type="checkbox"
                                        :checked="item.isMain === 1"
                                        @click="isMain(item.idx, 1)"
                                    />
                                    <em></em>
                                </label>
                            </td>
                            <td class="cnt"><button type="button" class="table_btn _gray" @click="confirmForDelete(item.idx)">삭제</button></td>
                        </tr>
                    </template>
                    <tr v-else>
                        <td colspan="8"><div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <PageBtn
            v-if="listState.list.length !== 0"
            :currentPage="listState.page"
            :totalLength="listState.totalLength"
            :perPage="listState.size"
            @onPaging="handlePageChange"
        ></PageBtn>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import { reactive, apiService, onMounted, ModalDefault, types, PageBtn, CommonUtils, getMessageByCode } from "@/BaseComponent";
    import { ResBoardVOForApi } from "@/types";

    export default {
        props: {},
        components: {
            ModalDefault,
            PageBtn,
        },
        setup() {
            const state = reactive({
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                idxForRemove: 0 as number,
            });

            const listState = reactive({
                list: [] as Array<ResBoardVOForApi>,
                page: 1 as number,
                size: 10 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,
            });

            onMounted(() => {
                getList();
            });

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    remove();
                }
            };

            const viewImage = async (param: string) => {
                state.modalTab = 11;
                state.modalTitle = "알림";
                state.modalContent = param;
                state.isShowModal = true;
            };

            const getList = async () => {
                listState.list = [];
                const param: types.ReqCommonPaging = {
                    page: listState.page,
                    size: listState.size,
                    searchType: null,
                    searchText: null,
                };
                const res = await apiService.board.listForMain(1, param);
                if (res.returnCode === 0) {
                    listState.list = res.list.data;
                    listState.totalPage = res.list.totalPages;
                    listState.totalLength = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                    listState.totalPage = 0;
                    listState.totalLength = 0;
                    listState.list = [];
                }
            };

            const handlePageChange = (page: number) => {
                listState.page = page;
                getList();
            };

            const isMain = async (idx: number, type: number) => {
                const res = await apiService.board.pick(idx);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "등록이 완료되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "등록이 불가능 합니다.";
                    state.isShowModal = true;
                }
                getList();
            };

            const confirmForDelete = async (idx: number) => {
                state.idxForRemove = idx;

                state.modalTab = 5;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
            };

            const remove = async () => {
                const param: types.ReqIdxList = {
                    idxList: state.idxForRemove + "",
                };
                const res = await apiService.board.remove(param);

                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제가 완료되었습니다.";
                    state.isShowModal = true;
                    state.idxForRemove = 0;
                    getList();
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const changeOrder = async (item: types.ResBoardVOForApi, arrow: number) => {
                const param: types.ReqBoardForOrder = {
                    idx: item.idx,
                    type: 1,
                    order: arrow,
                };
                const res = await apiService.board.changeOrder(param);
                if (res.returnCode === 0) {
                    getList();
                }
            };

            return {
                state,
                listState,
                types,
                viewImage,
                isMain,
                CommonUtils,
                handlePageChange,
                closeModal,
                callBackModal,
                confirmForDelete,
                changeOrder,
            };
        },
    };
</script>
